module.exports = __webpack_public_path__ + "xiaozhangxinxiang.png?4034223235fe792c815b4ae223e4877d";


//////////////////
// WEBPACK FOOTER
// ./static/assets/xiaozhangxinxiang.png
// module id = 546
// module chunks = 0